import React from "react";
import {IconProps} from "@/icons/icon";

const ArrowLeft: React.FC<IconProps> = () => {
  return (
    <svg
      style={{fill: "currentColor"}}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M14 7l-5 5 5 5V7z" />
      <path d="M24 0v24H0V0h24z" fill="none" />
    </svg>
  )
}

export default ArrowLeft
